import { CreationContext } from '../models/user/User';

/**
 * Détermine le creation_context selon le type de l'acteur connecté et le type du compte à créer.
 * Retourne null pour toute combinaison non autorisée (le backend rejettera de toute façon).
 */
export function determineCreationContext(
    actorUsertype: string,
    targetUsertype: string
): CreationContext | null {
    if (targetUsertype === 'MINOR') return 'delegated_child';
    if (actorUsertype === 'BUSINESS' && targetUsertype === 'ADULT') return 'delegated_adult';
    if (actorUsertype === 'BUSINESS' && targetUsertype === 'TEACHER') return 'delegated_teacher';
    return null;
}
